export default __webpack_public_path__ + "static/media/ic-arrow-left-blue.fe0928fc.svg";